import { Logo } from "@/components/Logo";
import { CONTACT_EMAIL } from "@/data/content";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-navy/60 backdrop-blur-md">
      <div className="mx-auto max-w-7xl px-6 py-14">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-8">
          <div>
            <Logo size={32} />
            <p className="mt-5 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-flame/80">
              Confidential, For Accredited Investors Only
            </p>
            <p className="mt-1.5 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-white/35">
              Regulation D Offering
            </p>
          </div>

          <div className="flex flex-col sm:items-end gap-3">
            <a
              data-testid="footer-email"
              href={`mailto:${CONTACT_EMAIL}`}
              className="font-body text-white/70 hover:text-flame transition-colors duration-300"
            >
              {CONTACT_EMAIL}
            </a>
            <span className="font-mono text-xs text-white/30">
              © {new Date().getFullYear()} U-TOPIA, Inc. · Puerto Rico C-Corp
            </span>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/[0.06]">
          <p className="font-body text-[0.7rem] leading-relaxed text-white/25 max-w-4xl">
            This material is confidential and intended solely for accredited investors. It does
            not constitute an offer to sell or a solicitation of an offer to buy any security.
            Any offering is made only pursuant to definitive subscription documents and applicable
            exemptions under Regulation D. Forward-looking statements involve risk and uncertainty.
          </p>
        </div>
      </div>
    </footer>
  );
}
